/** The OPD token queue: the diary's Queue view and booking by token at the desk. Conventions: see `common.ts`. */
const queue: Record<string, string> = {
  view: 'Queue',
  title: 'Token queue',
  date: 'Date',
  loading: 'Loading the queue…',
  load_error: 'The queue could not be loaded.',
  auto_refresh: 'Updates every 10 seconds',

  'empty.title': 'Nobody books by token yet',
  'empty.description':
    'Clinics that see patients by token number rather than at fixed times run their queue here. To switch a doctor to tokens, open My schedule (for your own diary) or Our team → the person → Booking settings, and choose "By token".',
  no_sessions: 'No sessions on this day - a day off, or time off.',

  'session.morning': 'Morning',
  'session.afternoon': 'Afternoon',
  'session.evening': 'Evening',
  'session.range': '{name} {from}–{to}',

  now_serving: 'Now serving',
  now_serving_none: 'Nobody called yet',
  'counts.waiting': 'Waiting',
  'counts.arrived': 'Arrived',
  'counts.done': 'Done',
  'counts.skipped': 'Skipped',
  call_next: 'Call next',
  call_next_hint: 'Marks whoever is in as done and calls the next patient - arrived patients first, by token.',
  issue: 'Issue token',
  no_tokens: 'No tokens issued in this session yet.',
  called: 'Token {number} called in: {name}',
  nobody_waiting: 'Nobody is waiting in this session.',
  updated: 'Token {number} updated',
  action_error: 'That did not go through. Please try again.',

  token: 'Token {number}',
  approx: '~{time}',
  approx_when: '{day}, ~{time}',
  approx_hint: 'Estimated - patients are seen in token order.',

  'status.waiting': 'Waiting',
  'status.arrived': 'Arrived',
  'status.serving': 'Now serving',
  'status.skipped': 'Skipped',
  'status.done': 'Done',
  'status.no_show': 'No-show',
  'status.cancelled': 'Cancelled',

  'actions.arrived': 'Arrived',
  'actions.undo_arrived': 'Undo arrived',
  'actions.call': 'Call',
  'actions.skip': 'Skip',
  'actions.done': 'Done',
  'actions.no_show': 'No-show',

  screen: 'Open waiting-room screen',
  screen_hint: 'Show "now serving" on a TV in the waiting room.',

  'desk.title': 'Token',
  'desk.by_token': 'By token',
  'desk.next': 'Next token #{number}',
  'desk.approx': 'approx {time}',
  'desk.left_one': '{count} left',
  'desk.left_other': '{count} left',
  'desk.full': 'Full',
  'desk.none': 'No sessions on this day. Try another date.',
  'desk.pick': 'Pick a session.',
  'desk.gone': 'That session is full or has closed. Pick another.',
  'desk.token_required': 'This doctor books by token - pick a session instead of a time.',
  issued: 'Token {number} for {name}',
};

export default queue;
